import type { IconProps } from './types';

export function Bermuda({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M68 48 Q128 44 188 48 Q188 60 188 72 Q186 130 184 192 Q164 196 144 192 Q136 144 128 96 Q120 144 112 192 Q92 196 72 192 Q70 130 68 72 Q68 60 68 48 Z" />
      <path d="M68 72 Q128 76 188 72" />
    </svg>
  );
}
